import { Button, Modal, SpaceBetween } from '@cloudscape-design/components';
import React, { useEffect, useState } from 'react';
import { ColorPicker, IColor, useColor } from 'react-color-palette';

interface DPColorModal {
    close?: boolean;
    clear?: boolean;
    color: string;
    text?: string
    //onDismiss: () => void;
    onColorSelect: (selectedDate: string) => void;
}
const DPColorModal: React.FC<DPColorModal> = ({
    close = false,
    clear = true,
    color = "#ffffff",
    text = "",
    onColorSelect,
}) => {
    const [selectedColor, setSelectedColor] = useColor(color);
    const [showModal, setShowModal] = useState<boolean>(false);

    /*const handleColorSelect = (event: { detail: { hex: string } }) => {
        const newColor = event.detail.hex;
        setSelectedColor(event.detail);
        if (onColorSelect)
            onColorSelect(newColor);
        //hideKeyboardGlobally();
        //onDismiss();
    };
    */
    const onDismiss = () => {
        setShowModal(false);
    }
    const colorClear = () => {
        setSelectedColor("#ffffff" as unknown as IColor);
        onColorSelect('');
    }
    useEffect(() => {

        //setShowModal(false);
    }, [selectedColor]);
    return (
        <>
            <div style={{ height: 20, ...(text === "" ? { width: 20 } : {}), backgroundColor: color, border: "1px solid #bbb", display: "inline-block", cursor: "pointer", borderRadius: 4 }} onClick={() => setShowModal(true)}>{text}</div >
            <Modal
                visible={showModal}
                onDismiss={onDismiss}
                size="small"
                header={"Seleccione un color"}
                footer={
                    <SpaceBetween direction='horizontal' size='xs'>
                        <Button variant='link' onClick={onDismiss}>Cancelar</Button>
                        {clear && <Button variant='link' onClick={colorClear}>Limpiar</Button>}
                        <Button variant='primary' onClick={() => {
                            onColorSelect(selectedColor.hex);
                            onDismiss();
                        }}>Aceptar</Button>
                    </SpaceBetween>
                }>
                <ColorPicker
                    color={selectedColor}
                    onChange={setSelectedColor}
                    hideInput={["rgb", "hsv", "rgb"]} // Simplifies the UI for users
                />

                <div style={{ marginTop: "20px" }}>
                    <div style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: selectedColor.hex,
                        borderRadius: "4px",
                        border: "1px solid #ccc"
                    }} />
                </div>

            </Modal >
        </>
    );
};

export default DPColorModal;